const img = require('./Frame.png'); export default img;